import { Helmet } from 'react-helmet-async';

/**
 * Reusable SEO component - drop into every page.
 *
 * Props:
 *  title  – <title> tag (aim ≤60 chars)
 *  description  – meta description (140–160 chars ideal)
 *  canonical  – canonical URL path, e.g. "/cybersecurity"
 *  ogImage  – absolute URL to OG share image
 *  ogType  – "website" | "article" (default "website")
 *  schema  – JSON-LD object (or array of objects)
 */

const SITE_URL = 'https://flynaut.com';
const DEFAULT_OG_IMAGE = 'https://cdn.flynaut.com/images/Logo.png';

export default function SEOHead({
  title,
  description,
  canonical,
  ogImage,
  ogType = 'website',
  schema,
  noIndex = false,
}) {
  const fullCanonical = `${SITE_URL}${canonical || ''}`;
  const image = ogImage || DEFAULT_OG_IMAGE;

  return (
  <Helmet>
  {/* Core */}
  <title>{title}</title>
  <meta name="description" content={description} />
  <link rel="canonical" href={fullCanonical} />
  {noIndex && <meta name="robots" content="noindex, nofollow" />}

  {/* Open Graph */}
  <meta property="og:title" content={title} />
  <meta property="og:description" content={description} />
  <meta property="og:url" content={fullCanonical} />
  <meta property="og:type" content={ogType} />
  <meta property="og:image" content={image} />
  <meta property="og:site_name" content="Flynaut" />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content={title} />
  <meta name="twitter:description" content={description} />
  <meta name="twitter:image" content={image} />

  {/* JSON-LD Structured Data */}
  {schema && (
  <script type="application/ld+json">
  {JSON.stringify(Array.isArray(schema) ? schema : [schema])}
  </script>
  )}
  </Helmet>
  );
}
